module.exports = __webpack_public_path__ + "img/pay_successed.c529bc0a.png";